import React from 'react';
import { string, arrayOf, object, func } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';
import { compose, concat, replace, lt, length, prop, head, ifElse, identity, startsWith } from 'ramda';

import CommunicationCard from './CommunicationCard';
import Tooltip from '../../core/components/tooltip/Tooltip';

const CardContainer = styled.div`
  width: 288px;
  height: 204px;
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 24px;
  margin: 12px;
`;

const Image = styled.img`
  width: 64px;
  height: 64px;
`;

const Text = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 8px;
  color: #4a4a4a;
  font-weight: 600;
`;

const Button = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  line-height: 1.43;
  border-radius: 1000px;
  border: solid 1px #f28000;
  background-color: #fff;
  padding: 6px 20px;
  color: #f28000;
  cursor: pointer;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Phone = styled.a`
  display: flex;
  flex-direction: row;
`;

const Label = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  color: #cccccc;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-end;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 22px;
`;

const Number = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  color: #4a4a4a;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 22px;
`;

const removeWhitespaces = replace(/\s/g, '');

const formatPhone = ifElse(
  startsWith('0800'),
  identity,
  compose(
    replace(/\s/, '-'),
    replace(/\s/, ')'),
    concat('('),
  ),
);

const formatNumber = compose(
  concat('tel:'),
  removeWhitespaces,
);

const firstNumber = compose(
  prop('number'),
  head,
);

const PhoneTooltipCard = ({
  phones, icon, text, button, posName, type, handleClick,
}) => (
  <CardContainer>
    <Image src={`${process.env.PUBLIC_URL}/images/${icon}.svg`} alt={text} />
    <Text>{text}</Text>
    <Tooltip trigger={<Button onClick={() => handleClick(posName, type)}>{button}</Button>}>
      <Container>
        {phones.map(phone => (
          <Phone key={shortid.generate()} href={formatNumber(phone.number)}>
            <Label>{phone.label}</Label>
            <Number>{phone.number}</Number>
          </Phone>))}
      </Container>
    </Tooltip>
  </CardContainer>
);

const PhoneCommunicationCard = ({
  phones, icon, text, button, posName, type, handleClick,
}) => (
  lt(1, length(phones))
    ? <PhoneTooltipCard posName={posName} type={type} handleClick={handleClick} icon={icon} text={text} button={button} phones={phones} />
    : <CommunicationCard posName={posName} type={type} handleClick={handleClick} icon={icon} text={text} button={`Ligar ${formatPhone(firstNumber(phones))}`} href={formatNumber(firstNumber(phones))} />
);

PhoneTooltipCard.propTypes = {
  phones: arrayOf(object).isRequired,
  icon: string.isRequired,
  text: string.isRequired,
  button: string.isRequired,
  posName: string.isRequired,
  type: string.isRequired,
  handleClick: func.isRequired,
};

PhoneCommunicationCard.propTypes = {
  phones: arrayOf(object).isRequired,
  icon: string.isRequired,
  text: string.isRequired,
  button: string.isRequired,
  posName: string.isRequired,
  type: string.isRequired,
  handleClick: func.isRequired,
};

export default PhoneCommunicationCard;
